import { RhinoError } from '../../error';
import { request } from '../../network';
import { getDeviceConfiguration } from '../configuration/getDeviceConfiguration';

export function fetchDictionary(lang: string) {
  const configuration = getDeviceConfiguration();

  if (!configuration) {
    throw new Error('Device Configuration is empty. Did you forget to initRhino?');
  }

  const dictionaryUrl = configuration.translationDictionaries[lang];

  if (!dictionaryUrl) {
    throw new RhinoError('CONFIGURATION', 'There is no any dictionary corresponding to the given language');
  }

  return request<Record<string, string>>({
    url: dictionaryUrl,
    method: 'get',
  });
}
